var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333H16.6667",
    stroke: "#1E434D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 17.5C36.6667 17.3717 36.6667 16.6117 36.6633 16.5583C36.6033 15.7233 35.8883 15.0583 34.9883 15.0033C34.9317 15 34.8633 15 34.7233 15H30.3867C27.41 15 25 17.2383 25 20C25 22.7617 27.4117 25 30.3833 25H34.7217C34.8617 25 34.93 25 34.9883 24.9967C35.8883 24.9417 36.605 24.2767 36.6633 23.4417C36.6667 23.3883 36.6667 22.6283 36.6667 22.5",
    stroke: "#1E434D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 21.6666C30.9204 21.6666 31.6666 20.9204 31.6666 19.9999C31.6666 19.0794 30.9204 18.3333 29.9999 18.3333C29.0794 18.3333 28.3333 19.0794 28.3333 19.9999C28.3333 20.9204 29.0794 21.6666 29.9999 21.6666Z",
    fill: "#1E434D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 6.66663C27.9516 6.66663 31.0949 6.66663 33.0466 8.61996C34.3949 9.96663 34.8133 11.88 34.9416 15M16.6666 33.3333H21.6666C27.9516 33.3333 31.0949 33.3333 33.0466 31.38C34.3949 30.0333 34.8133 28.12 34.9416 25M14.9999 6.66663C9.80992 6.68329 7.05825 6.84663 5.28659 8.61996C3.33325 10.5716 3.33325 13.715 3.33325 20C3.33325 26.285 3.33325 29.4283 5.28659 31.38C6.37492 32.47 7.83325 32.9516 9.99992 33.1633",
    stroke: "#1E434D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCep);
export default __webpack_public_path__ + "static/media/cep.9407360106bed9e829ba14de0684b359.svg";
export { ForwardRef as ReactComponent };